import { CategoryMutationResult, ProductCategory, ProductCategorySub } from '@features/catalog/models/product-category.models';
import {
  GraphqlMutationCategoryPayloadDto,
  GraphqlProductCategoryDto,
} from '../dto/product-category.dto';
import { normalizeGraphqlErrors } from './graphql-error.mapper';

export function mapSubcategoryDto(dto: GraphqlProductCategoryDto): ProductCategorySub {
  return {
    id: String(dto.id),
    name: dto.name,
    parentId: dto.parentId != null ? String(dto.parentId) : null,
    slug: dto.slug?.trim() || undefined,
    active: dto.active ?? undefined,
    position: dto.position ?? null,
    iconName: dto.iconName?.trim() || null,
    productsCount: dto.productsCount ?? undefined,
  };
}

export function mapProductCategoryDto(dto: GraphqlProductCategoryDto): ProductCategory {
  return {
    id: String(dto.id),
    name: dto.name,
    slug: dto.slug?.trim() ?? '',
    active: dto.active ?? true,
    position: dto.position ?? null,
    parentId: dto.parentId != null ? String(dto.parentId) : null,
    iconName: dto.iconName?.trim() || null,
    productsCount: dto.productsCount ?? 0,
    fulfillmentLeadTimeMode: dto.fulfillmentLeadTimeMode === 'override' ? 'override' : 'inherit',
    fulfillmentLeadTimeDays: dto.fulfillmentLeadTimeDays ?? null,
    prepRequiresMode: dto.prepRequiresMode === 'override' ? 'override' : 'inherit',
    prepRequires: dto.prepRequires ?? true,
    prepTimeMinutes: dto.prepTimeMinutes ?? null,
    subcategories: (dto.subcategories ?? []).map(mapSubcategoryDto),
  };
}

export function flattenProductCategoryForest(roots: GraphqlProductCategoryDto[]): ProductCategory[] {
  const out: ProductCategory[] = [];
  const visit = (dto: GraphqlProductCategoryDto): void => {
    out.push({
      id: String(dto.id),
      name: dto.name,
      slug: dto.slug?.trim() ?? '',
      active: dto.active ?? true,
      position: dto.position ?? null,
      parentId: dto.parentId != null ? String(dto.parentId) : null,
      iconName: dto.iconName?.trim() || null,
      productsCount: dto.productsCount ?? 0,
      fulfillmentLeadTimeMode: dto.fulfillmentLeadTimeMode === 'override' ? 'override' : 'inherit',
      fulfillmentLeadTimeDays: dto.fulfillmentLeadTimeDays ?? null,
      prepRequiresMode: dto.prepRequiresMode === 'override' ? 'override' : 'inherit',
      prepRequires: dto.prepRequires ?? true,
      prepTimeMinutes: dto.prepTimeMinutes ?? null,
      subcategories: [],
    });
    for (const child of dto.subcategories ?? []) {
      visit(child);
    }
  };
  for (const root of roots) {
    visit(root);
  }
  return out;
}

export function asDtoArray(
  raw: GraphqlProductCategoryDto | GraphqlProductCategoryDto[] | null | undefined
): GraphqlProductCategoryDto[] {
  if (raw == null) {
    return [];
  }
  return Array.isArray(raw) ? raw : [raw];
}

export function mapMutationPayload(payload?: GraphqlMutationCategoryPayloadDto | null): CategoryMutationResult {
  if (!payload) {
    return { category: null, errors: ['Respuesta vacía del servidor'] };
  }
  const errors = normalizeGraphqlErrors(payload.errors);
  const category = payload.category ? mapProductCategoryDto(payload.category) : null;
  return { category, errors };
}
